<template>
  <div class="audit-popup">
    <div class="default-modal">
      <el-dialog
        v-model="AuditLogsPopup"
        class="existed-caseinfo-dialog"
        @close="close"
      >
        <div class="dialog-header">
          <span class="header-part"> Audit </span>
          <el-button
            size="medium"
            class="el-white"
            type="info"
            plain
            @click="close"
          >
            <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon"
          /></el-button>
        </div>
        <div class="all-cases-view">
          <div class="popup-date">
            <div class="primary-content-view-new" v-loading="loading">
              <div
                class="listings listings__table listings__all-cases"
                id="all-cases-listings"
              >
                <el-table :data="getAllLogs.data">
                  <el-table-column label="TIME" width="180">
                    <template #default="scope">
                      <div v-if="scope.row.created_at" class="d-flex">
                        <div class="date pr-10">
                          {{
                            momentWithTimezone(
                              scope.row.created_at,
                              "MM-DD-yyyy hh:mm A"
                            )
                          }}
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="ACTION PERFORMED">
                    <template #default="scope">
                      <span class="error-break">{{
                        scope.row.description
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="PERFORMED BY" width="200">
                    <template #default="scope">
                      {{
                        scope.row.user
                          ? scope.row.user.first_name +
                            " " +
                            scope.row.user.last_name
                          : ""
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column label="ACTION REASON" width="200">
                    <template #default="scope">
                      {{ scope.row.reason }}
                    </template>
                  </el-table-column>
                  <el-table-column label="Actions">
                    <template #default="scope">
                      <el-button
                        v-if="
                          scope.row.changed_data &&
                          scope.row.changed_data.length > 0
                        "
                        class="btn small-add-test-btn"
                        style="border: none"
                        @click="showDetails(scope.row.changed_data)"
                      >
                        Show Details
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="listings listings__pagination">
                  <el-pagination
                    v-model:currentPage="page"
                    v-model:page-size="pageSize"
                    :page-sizes="[10, 25, 50, 100]"
                    layout="prev, pager, next, jumper, sizes, total"
                    :total="getAllLogs.total"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
    <div class="default-modal blue-background">
      <el-dialog v-model="dialogVisible" width="60%">
        <div class="dialog-header">
          <span class="header-part"> Changed Details </span>
        </div>
        <div class="all-cases-view">
          <div class="popup-date">
            <div class="primary-content-view-new" v-loading="loading">
              <div
                class="listings listings__table listings__all-cases"
                id="all-cases-listings"
              >
                <el-table :data="selectedDetails" style="width: 100%">
                  <el-table-column prop="key" label="Field Name">
                    <template #default="{ row }">
                      {{ formatKey(row.key) }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="previous_value"
                    label="Initial Data"
                  />
                  <el-table-column prop="present_value" label="Updated Data" />
                </el-table>
              </div>
            </div>
          </div>
        </div>
        <div class="close-btn">
          <el-button @click="dialogVisible = false">Close</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["caseId", "orderId"],
  data() {
    return {
      AuditLogsPopup: true,
      loading: false,
      page: 1,
      pageSize: 25,
      selectedDetails: [],
      dialogVisible: false,
    };
  },
  async mounted() {
   await this.fetchAuditLogs();
  },
  computed: {
    ...mapGetters("logs", ["getAllLogs"]),
  },
  methods: {
    formatKey(key) {
      return key
        .replace(/_/g, " ")
        .replace(/\./g, " - ")
        .replace(/^\w/, (c) => c.toUpperCase());
    },
    showDetails(data) {
      this.dialogVisible = true;
      this.selectedDetails = data;
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;

      this.fetchAuditLogs();
    },
    handleCurrentChange(page) {
      this.page = page;

      this.fetchAuditLogs();
    },
    prepareParams() {
      const params = {
        page: this.page,
        limit: this.pageSize,
      };
      if (this.caseId) {
        params.case_id = this.caseId;
      }
      if (this.orderId) {
        params.order_id = this.orderId;
      }
      if (!this.isBillingUser) {
        params.audit_section = "BILLING";
      }
      if (this.isBillingUser) {
        params.audit_section = "TESTING";
      }
      return params;
    },
    async fetchAuditLogs() {
      try {
        this.loading = true;
        let params = this.prepareParams();

        await this.$store.dispatch("logs/fetchAllLogs", params);
        this.loading = false;
      } catch (err) {
        console.log(err);
      }
    },
    close() {
      this.$emit("close", false);
    },
  },
};
</script>
<style lang="scss">
.audit-popup {
  .default-modal {
    .listings__table .el-table table thead tr th .cell {
      padding: 3px 10px !important;
    }
    &.blue-background{
      .listings__table .el-table table thead tr th.el-table__cell{
      background: #273480;
    }
     .listings__table .el-table table thead tr th .cell{
      color:#fff;
     }
    }
 
    .listings__table .el-table table tbody tr:nth-child(odd) {
      background-color: #f2f2f2;
    }
    .listings__table .el-table table tbody td.el-table__cell {
      border: none !important;
    }
    .el-dialog {
      width: 75% !important;
      @media (min-width: 1700px) and (max-width: 2500px) {
        width: 60%;
      }
    }
    .listings__table .el-table table tbody tr td .cell {
      padding: 3px 10px !important;
      display: block;
      overflow-wrap: break-word;
    }
  }
  .close-btn {
    text-align: end;
    padding: 0 1rem 0.5rem;
    .el-button {
      min-height: 30px;
      padding: 0 1.3rem;
      color: #ffffff;
      background-color: #eb5757;
      border-radius: 7px;
      border: none;
      &:hover,
      &:focus {
        background-color: #eb5757;
        color: #ffffff;
        border: none;
      }
    }
  }
}
</style>
